/* ==================================================================
   BRICOVIBE — confort de navigation (bv-ux.js)
   Chargé en fin de page (defer) par layout/theme.liquid, après les
   scripts Dawn (constants.js, pubsub.js, global.js, cart-drawer.js).
   Chaque bloc est indépendant : une erreur dans l'un n'empêche pas les
   autres de fonctionner.
   ================================================================== */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var html = d.documentElement;
  var reduceMotion = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches); /* Fiche produit mobile : loupe dans l'en-tête (ouvre le menu sur le champ de recherche) */ try { (function () { if (!d.body || !d.body.classList.contains('template-product')) return; var a = d.querySelector('.bv-header__top .bv-header__actions'); var bg = d.querySelector('.bv-burger'); if (!a || !bg || a.querySelector('.bv-msearch')) return; var s = d.createElement('button'); s.type = 'button'; s.className = 'bv-circle bv-msearch'; s.setAttribute('aria-label', 'Rechercher'); var ic = d.querySelector('.bv-search--mobile button svg, .bv-search--mobile svg'); s.innerHTML = ic ? ic.outerHTML : ''; s.addEventListener('click', function () { bg.click(); var f = function () { var i = d.querySelector('.bv-drawer__search input'); if (i) i.focus({ preventScroll: true }); }; f(); setTimeout(f, 350); }); a.insertBefore(s, a.firstChild); })(); } catch (e) {}
  /* Avis : ne pas afficher la mention « Taille / Modèle acheté(e) » */ try { (function () { var re = /^\s*(Taille|Modèle) achet/i; var run = function () { var l = d.querySelectorAll('.trustap-review-title, .trustap-full-review__review-title'); for (var i = 0; i < l.length; i++) { if (re.test(l[i].textContent)) l[i].style.display = 'none'; } }; run(); var p = 0; new MutationObserver(function () { if (p) return; p = 1; requestAnimationFrame(function () { p = 0; run(); }); }).observe(d.body, { childList: true, subtree: true }); })(); } catch (e) {} /* Fiche : bouton « Voir les avis » sous le titre, descend jusqu'à la liste complète des avis */ try { (function () { var box = d.querySelector('.bv-stars-above-price .trustap-star-rating'); var fr = d.querySelector('.trustap-full-review'); var sec = fr && (fr.closest('.shopify-section') || fr); if (!box || !sec || box.querySelector('.bv-see-reviews')) return; var b = d.createElement('button'); b.type = 'button'; b.className = 'bv-see-reviews'; b.textContent = 'Voir les avis'; b.style.cssText = 'margin-left:10px;padding:0;border:0;background:none;color:inherit;font:inherit;font-size:14px;font-weight:700;text-decoration:underline;text-underline-offset:3px;cursor:pointer;white-space:nowrap'; box.appendChild(b); box.style.cursor = 'pointer'; box.setAttribute('title', 'Voir tous les avis'); box.addEventListener('click', function (e) { e.preventDefault(); var hd = d.querySelector('.bv-header--sticky'); var off = hd ? hd.getBoundingClientRect().height : 0; var y = sec.getBoundingClientRect().top + w.pageYOffset - off - 12; w.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' }); }); })(); } catch (e) {} var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function el(tag, attrs, inner) {
    var n = d.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (inner != null) n.innerHTML = inner;
    return n;
  }
  function store(k, v) {
    try {
      if (v === undefined) return w.localStorage.getItem(k);
      if (v === null) w.localStorage.removeItem(k); else w.localStorage.setItem(k, v);
    } catch (e) { return null; }
    return null;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function safe(name, fn) { try { fn(); } catch (e) { if (w.console) console.warn('[bv-ux] ' + name, e); } }
  function money(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  var ICON = {
    up: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    link: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1"/></svg>',
    print: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="8" rx="2"/><path d="M6 14h12v7H6z"/></svg>',
    eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    eyeOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3l18 18"/><path d="M10.6 5.1A10.9 10.9 0 0 1 12 5c6.4 0 10 7 10 7a17.6 17.6 0 0 1-3.3 4.2M6.6 6.6A17.4 17.4 0 0 0 2 12s3.6 7 10 7a9.8 9.8 0 0 0 5.4-1.6"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    folder: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6M8 13h8M8 17h5"/></svg>'
  };

  /* Notifications (toasts) — window.bvToast(message, { type, action }) */
  var toastWrap = null;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastWrap) {
      toastWrap = el('div', { class: 'bv-toasts', role: 'status', 'aria-live': 'polite' });
      d.body.appendChild(toastWrap);
    }
    var t = el('div', { class: 'bv-toast bv-toast--' + (opts.type || 'ok') });
    if (opts.type === 'err') t.setAttribute('role', 'alert');
    t.innerHTML = '<span class="bv-toast__icon" aria-hidden="true"></span><span class="bv-toast__msg"></span>';
    t.querySelector('.bv-toast__msg').textContent = msg;
    var timer;
    function close() {
      clearTimeout(timer);
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 260);
    }
    if (opts.action) {
      var a = el('button', { type: 'button', class: 'bv-toast__act' });
      a.textContent = opts.action.label;
      a.addEventListener('click', function () { close(); opts.action.fn(); });
      t.appendChild(a);
    }
    var x = el('button', { type: 'button', class: 'bv-toast__x', 'aria-label': 'Fermer la notification' }, '&times;');
    x.addEventListener('click', close);
    t.appendChild(x);
    toastWrap.appendChild(t);
    while (toastWrap.children.length > 3) toastWrap.removeChild(toastWrap.firstChild);
    requestAnimationFrame(function () { requestAnimationFrame(function () { t.classList.add('is-in'); }); });
    timer = setTimeout(close, opts.duration || (opts.type === 'err' ? 7000 : 4500));
    return close;
  }
  w.bvToast = toast;

  /* 1. Mode sombre (préférence mémorisée à la demande du visiteur) */
  function applyTheme(t, save) {
    var dark = t === 'dark';
    if (dark) html.setAttribute('data-theme', 'dark'); else html.removeAttribute('data-theme');
    if (save) store('bv-theme', dark ? 'dark' : 'light');
    $$('[data-bv-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode sombre');
      b.setAttribute('title', dark ? 'Mode clair' : 'Mode sombre');
      var lbl = b.querySelector('[data-bv-theme-label]');
      if (lbl) lbl.textContent = dark ? 'Mode clair' : 'Mode sombre';
    });
    var meta = $('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', dark ? '#141413' : '#ffffff');
  }
  safe('theme', function () {
    applyTheme(html.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bv-theme-toggle]');
      if (!b) return;
      e.preventDefault();
      if (!reduceMotion) html.classList.add('bv-theme-anim');
      applyTheme(html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark', true);
      setTimeout(function () { html.classList.remove('bv-theme-anim'); }, 420);
    });
  });

  /* 4 + 8 + 11. Barre de défilement, retour en haut, en-tête collant */
  safe('scroll', function () {
    var bar = el('div', { class: 'bv-progress', 'aria-hidden': 'true' }, '<span></span>');
    var fill = bar.firstChild;
    var top = el('button', { type: 'button', class: 'bv-totop', 'aria-label': 'Retour en haut de la page', title: 'Retour en haut' }, ICON.up);
    d.body.appendChild(bar);
    d.body.appendChild(top);
    top.addEventListener('click', function () {
      w.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var logo = $('.bv-header__logo');
      if (logo) setTimeout(function () { logo.focus({ preventScroll: true }); }, reduceMotion ? 0 : 500);
    });
    var ticking = false;
    function bottomUi() {
      var off = 0;
      var satc = $('.bv-satc');
      if (satc) {
        var r = satc.getBoundingClientRect();
        if (r.height > 0 && r.top < w.innerHeight - 2 && r.bottom > 0 && getComputedStyle(satc).visibility !== 'hidden') off = Math.max(off, w.innerHeight - r.top);
      }
      var ck = $('.bv-cookie.is-open');
      if (ck && w.innerWidth < 750) off = Math.max(off, w.innerHeight - ck.getBoundingClientRect().top);
      return off;
    }
    function onScroll() {
      ticking = false;
      var y = w.scrollY || html.scrollTop;
      var h = html.scrollHeight - w.innerHeight;
      fill.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
      top.classList.toggle('is-on', y > 700);
      var off = bottomUi();
      top.style.setProperty('--bv-totop-off', off + 'px');
      html.style.setProperty('--bv-bottom-ui', off + 'px');
      html.classList.toggle('bv-scrolled', y > 8);
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }
    w.addEventListener('scroll', req, { passive: true });
    w.addEventListener('resize', req);
    w.bvRefreshBottom = req;
    onScroll();
  });

  /* 6. Barre de chargement entre les pages */
  safe('navload', function () {
    var bar = el('div', { class: 'bv-navload', 'aria-hidden': 'true' });
    d.body.appendChild(bar);
    function start() { bar.classList.remove('is-on'); void bar.offsetWidth; bar.classList.add('is-on'); }
    d.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      setTimeout(function () { if (!e.defaultPrevented) start(); }, 0);
    });
    d.addEventListener('submit', function (e) {
      setTimeout(function () { if (!e.defaultPrevented) start(); }, 0);
    });
    w.addEventListener('pageshow', function () { bar.classList.remove('is-on'); });
  });

  /* 6 bis. Chargement : squelettes d'images, apparition des sections */
  var MEDIA_BOX = '.bv-card__media, .bv-catcard__media, .bv-blog-card__media, .bv-cd__card-media, .bv-cd__media, .bv-edito__media, .bv-post__media, .bv-ps__img, .bv-terr__photo';
  function watchImg(img) {
    if (img.dataset.bvImg) return;
    img.dataset.bvImg = '1';
    if (img.complete && img.naturalWidth) return;
    var box = img.closest(MEDIA_BOX);
    img.classList.add('bv-img-wait');
    if (box) box.classList.add('bv-img-skel');
    function done() {
      img.classList.remove('bv-img-wait');
      img.classList.add('bv-img-in');
      if (box) box.classList.remove('bv-img-skel');
    }
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }
  function watchImages(root) { $$('img[loading="lazy"]', root).forEach(watchImg); }
  w.bvWatchImages = watchImages;
  safe('images', function () { watchImages(d); });

  safe('reveal', function () {
    if (reduceMotion || !('IntersectionObserver' in w)) return;
    var vh = w.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    $$('#MainContent > .shopify-section').forEach(function (s) {
      var r = s.getBoundingClientRect();
      if (r.top < vh * 0.92 || r.height < 60) return;
      if (s.querySelector('.bv-satc, [class*="sticky"], dialog, product-modal, cart-drawer')) return;
      s.classList.add('bv-reveal');
      io.observe(s);
    });
    setTimeout(function () { $$('.bv-reveal:not(.is-in)').forEach(function (s) { if (s.getBoundingClientRect().top < w.innerHeight) s.classList.add('is-in'); }); }, 2500);
  });

  /* 3. Recherche instantanée sur tout le site (produits, rayons, guides, pages) */
  var searchCount = 0;
  function highlight(text, q) {
    var t = esc(text);
    var words = q.trim().split(/\s+/).filter(function (x) { return x.length > 1; }).map(function (x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return t;
    try { return t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>'); } catch (e) { return t; }
  }
  function imgUrl(u, width) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function initSearch(root) {
    if (root.dataset.bvSearchReady) return;
    root.dataset.bvSearchReady = '1';
    var input = root.querySelector('input[type="search"]');
    var form = input && input.form;
    if (!input || !form) return;
    searchCount += 1;
    var listId = 'bv-ps-' + searchCount;
    var panel = el('div', { class: 'bv-ps', id: listId, role: 'listbox', 'aria-label': 'Suggestions de recherche', hidden: '' });
    root.appendChild(panel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', listId);
    input.setAttribute('autocomplete', 'off');
    var cache = {};
    var ctrl = null;
    var timer = null;
    var active = -1;
    var lastQ = '';

    function options() { return $$('[role="option"]', panel); }
    function setActive(i) {
      var opts = options();
      opts.forEach(function (o) { o.removeAttribute('aria-selected'); });
      if (!opts.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
      active = (i + opts.length) % opts.length;
      var o = opts[active];
      o.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', o.id);
      o.scrollIntoView({ block: 'nearest' });
    }
    function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function searchUrl(q) { return (w.routes && w.routes.search_url ? w.routes.search_url : '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

    function render(q, res) {
      var r = (res && res.resources && res.resources.results) || {};
      var n = 0;
      var out = '';
      function oid() { n += 1; return listId + '-o' + n; }
      var queries = (r.queries || []).filter(function (x) { return norm(x.text) !== norm(q); }).slice(0, 4);
      if (queries.length) {
        out += '<div class="bv-ps__group"><p class="bv-ps__head">Suggestions</p><ul>';
        queries.forEach(function (x) { out += '<li><a role="option" id="' + oid() + '" href="' + esc(x.url || searchUrl(x.text)) + '"><span class="bv-ps__ico">' + ICON.search + '</span><span class="bv-ps__txt"><span class="bv-ps__title">' + highlight(x.text, q) + '</span></span></a></li>'; });
        out += '</ul></div>';
      }
      var products = (r.products || []).slice(0, 6);
      if (products.length) {
        out += '<div class="bv-ps__group"><p class="bv-ps__head">Produits</p><ul>';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = money(p.price);
          var cmp = parseFloat(p.compare_at_price_max || 0) > parseFloat(p.price || 0) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
          out += '<li><a role="option" id="' + oid() + '" href="' + esc(p.url) + '"><span class="bv-ps__img">' + (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span><span class="bv-ps__txt"><span class="bv-ps__title">' + highlight(p.title, q) + '</span>' + (price ? '<span class="bv-ps__price">' + price + cmp + '</span>' : '') + (p.available === false ? '<span class="bv-ps__sub">Indisponible</span>' : '') + '</span></a></li>';
        });
        out += '</ul></div>';
      }
      var cols = (r.collections || []).slice(0, 4);
      if (cols.length) {
        out += '<div class="bv-ps__group"><p class="bv-ps__head">Rayons</p><ul>';
        cols.forEach(function (c) { out += '<li><a role="option" id="' + oid() + '" href="' + esc(c.url) + '"><span class="bv-ps__ico">' + ICON.folder + '</span><span class="bv-ps__txt"><span class="bv-ps__title">' + highlight(c.title, q) + '</span></span></a></li>'; });
        out += '</ul></div>';
      }
      var arts = (r.articles || []).slice(0, 4);
      if (arts.length) {
        out += '<div class="bv-ps__group"><p class="bv-ps__head">Guides et conseils</p><ul>';
        arts.forEach(function (a) { out += '<li><a role="option" id="' + oid() + '" href="' + esc(a.url) + '"><span class="bv-ps__ico">' + ICON.doc + '</span><span class="bv-ps__txt"><span class="bv-ps__title">' + highlight(a.title, q) + '</span></span></a></li>'; });
        out += '</ul></div>';
      }
      var pages = (r.pages || []).slice(0, 3);
      if (pages.length) {
        out += '<div class="bv-ps__group"><p class="bv-ps__head">Pages</p><ul>';
        pages.forEach(function (pg) { out += '<li><a role="option" id="' + oid() + '" href="' + esc(pg.url) + '"><span class="bv-ps__ico">' + ICON.doc + '</span><span class="bv-ps__txt"><span class="bv-ps__title">' + highlight(pg.title, q) + '</span></span></a></li>'; });
        out += '</ul></div>';
      }
      if (!products.length && !cols.length && !arts.length && !pages.length) {
        out += '<p class="bv-ps__empty">Aucun résultat pour « ' + esc(q) + ' ». Essayez un mot plus court ou un autre terme (échelle, perceuse, détecteur…).</p>';
      }
      out += '<a role="option" id="' + oid() + '" class="bv-ps__all" href="' + esc(searchUrl(q)) + '">Voir tous les résultats pour « ' + esc(q) + ' » <span aria-hidden="true">→</span></a>';
      panel.innerHTML = out;
      active = -1;
      watchImages(panel);
      open();
    }

    function run(q) {
      lastQ = q;
      if (cache[q]) { render(q, cache[q]); return; }
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = w.AbortController ? new AbortController() : null;
      panel.innerHTML = '<p class="bv-ps__loading">Recherche en cours…</p>';
      open();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,page,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
      fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (json) { cache[q] = json; if (q === lastQ) render(q, json); })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (q !== lastQ) return;
          panel.innerHTML = '<p class="bv-ps__empty">La recherche instantanée ne répond pas pour le moment. Appuyez sur Entrée pour lancer une recherche complète.</p><a role="option" id="' + listId + '-oerr" class="bv-ps__all" href="' + esc(searchUrl(q)) + '">Rechercher « ' + esc(q) + ' » <span aria-hidden="true">→</span></a>';
          open();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); panel.innerHTML = ''; return; }
      timer = setTimeout(function () { run(q); }, 200);
    });
    input.addEventListener('focus', function () { if (panel.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden && input.value.trim().length >= 2) run(input.value.trim()); else setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter') { var o = options()[active]; if (!panel.hidden && o) { e.preventDefault(); o.click(); } }
      else if (e.key === 'Escape') { if (!panel.hidden) { e.preventDefault(); close(); } else { input.value = ''; } }
    });
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); toast('Saisissez un mot à rechercher (produit, rayon, guide…).', { type: 'info' }); }
    });
    d.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    root.addEventListener('focusout', function () { setTimeout(function () { if (!root.contains(d.activeElement)) close(); }, 120); });
  }
  safe('search', function () {
    $$('[data-bv-search]').forEach(initSearch);
    d.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      var inputs = $$('[data-bv-search] input[type="search"]').filter(function (i) { return i.offsetParent !== null; });
      if (inputs.length) { e.preventDefault(); inputs[0].focus(); inputs[0].select(); }
    });
  });

  /* 5. Menu mobile : fermeture au clic, rubrique active ouverte */
  safe('menu', function () {
    var drawer = $('#bv-drawer');
    if (!drawer) return;
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (a) { var c = drawer.querySelector('[data-bv-close]'); if (c) setTimeout(function () { c.click(); }, 60); }
    });
    var here = location.pathname;
    $$('a[href]', drawer).forEach(function (a) {
      if (a.getAttribute('href') === here) {
        a.classList.add('is-active');
        var g = a.closest('details');
        if (g) { g.open = true; var s = g.querySelector('summary'); if (s) s.classList.add('is-active'); }
      }
    });
  });

  /* 2. Bandeau cookies (API de consentement Shopify) */
  var CONSENT_KEY = 'bv-consent';
  function withPrivacy(cb) {
    var S = w.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.setTrackingConsent) { cb(S.customerPrivacy); return; }
    if (S && typeof S.loadFeatures === 'function') {
      try {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { cb(err ? null : (w.Shopify.customerPrivacy || null)); });
      } catch (e) { cb(null); }
    } else { cb(null); }
  }
  function storedConsent() { var c = store(CONSENT_KEY); if (!c) return null; try { return JSON.parse(c); } catch (e) { return null; } }
  function analyticsAllowed() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) return true;
    } catch (e) { /* rien */ }
    var c = storedConsent();
    return !!(c && c.a === 1);
  }
  var cookieBox = null;
  function buildCookie() {
    if (cookieBox) return cookieBox;
    cookieBox = el('div', { class: 'bv-cookie', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'bv-cookie-title', 'aria-describedby': 'bv-cookie-text' });
    cookieBox.innerHTML =
      '<p class="bv-cookie__title" id="bv-cookie-title">Vos préférences de cookies</p>' +
      '<p class="bv-cookie__text" id="bv-cookie-text">Avec votre accord, nous utilisons des cookies de mesure d’audience et de publicité, modifiables à tout moment en bas de page. <a href="/pages/politique-de-confidentialite">En savoir plus</a></p>' +
      '<div class="bv-cookie__prefs" hidden>' +
        '<label class="bv-cookie__opt"><span><strong>Nécessaires</strong><small>Panier, connexion, sécurité du paiement. Toujours actifs.</small></span><input type="checkbox" checked disabled aria-label="Cookies nécessaires, toujours actifs"></label>' +
        '<label class="bv-cookie__opt"><span><strong>Mesure d’audience</strong><small>Statistiques de visite pour améliorer le site.</small></span><input type="checkbox" data-k="analytics"></label>' +
        '<label class="bv-cookie__opt"><span><strong>Publicité</strong><small>Mesure de nos campagnes (Google, réseaux sociaux) et annonces adaptées.</small></span><input type="checkbox" data-k="marketing"></label>' +
        '<label class="bv-cookie__opt"><span><strong>Préférences</strong><small>Mémorisation de certains choix d’affichage.</small></span><input type="checkbox" data-k="preferences"></label>' +
      '</div>' +
      '<div class="bv-cookie__actions">' +
        '<button type="button" class="bv-cookie__btn" data-c="reject">Tout refuser</button>' +
        '<button type="button" class="bv-cookie__btn" data-c="accept">Tout accepter</button>' +
        '<button type="button" class="bv-cookie__btn bv-cookie__btn--save" data-c="save" hidden>Enregistrer mes choix</button>' +
        '<button type="button" class="bv-cookie__btn bv-cookie__btn--link" data-c="custom" aria-expanded="false">Personnaliser</button>' +
      '</div>';
    d.body.appendChild(cookieBox);
    cookieBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-c]');
      if (!b) return;
      var c = b.getAttribute('data-c');
      if (c === 'accept') saveConsent({ analytics: true, marketing: true, preferences: true });
      else if (c === 'reject') saveConsent({ analytics: false, marketing: false, preferences: false });
      else if (c === 'custom') showPrefs(true);
      else if (c === 'save') {
        var v = {};
        $$('input[data-k]', cookieBox).forEach(function (i) { v[i.getAttribute('data-k')] = i.checked; });
        saveConsent(v);
      }
    });
    cookieBox.addEventListener('keydown', function (e) { if (e.key === 'Escape' && storedConsent()) closeCookie(); });
    return cookieBox;
  }
  function showPrefs(on) {
    var box = buildCookie();
    $('.bv-cookie__prefs', box).hidden = !on;
    $('[data-c="save"]', box).hidden = !on;
    $('[data-c="custom"]', box).hidden = on;
    $('[data-c="custom"]', box).setAttribute('aria-expanded', on ? 'true' : 'false');
    var c = storedConsent();
    $$('input[data-k]', box).forEach(function (i) {
      var k = i.getAttribute('data-k');
      i.checked = !!(c && c[k.charAt(0)] === 1);
    });
    if (on) { var first = $('input[data-k]', box); if (first) first.focus(); }
    if (w.bvRefreshBottom) w.bvRefreshBottom();
  }
  function openCookie(prefs) {
    var box = buildCookie();
    showPrefs(!!prefs);
    requestAnimationFrame(function () { box.classList.add('is-open'); if (w.bvRefreshBottom) w.bvRefreshBottom(); });
    if (prefs) setTimeout(function () { var f = $('input[data-k]', box); if (f) f.focus(); }, 60);
  }
  function closeCookie() { if (cookieBox) cookieBox.classList.remove('is-open'); setTimeout(function () { if (w.bvRefreshBottom) w.bvRefreshBottom(); }, 320); }
  function saveConsent(c) {
    var rec = { a: c.analytics ? 1 : 0, m: c.marketing ? 1 : 0, p: c.preferences ? 1 : 0, t: Date.now() };
    store(CONSENT_KEY, JSON.stringify(rec));
    closeCookie();
    withPrivacy(function (cp) {
      if (cp && typeof cp.setTrackingConsent === 'function') {
        try {
          cp.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing }, function () { utmFlush(); });
        } catch (e) { utmFlush(); }
      } else { utmFlush(); }
    });
    toast(c.analytics || c.marketing ? 'Vos choix de cookies sont enregistrés. Merci !' : 'C’est noté : seuls les cookies nécessaires sont utilisés.');
  }
  safe('cookies', function () {
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-bv-cookies]'); if (b) { e.preventDefault(); openCookie(true); } });
    var copy = $('.bv-footer__copy');
    if (copy && !$('[data-bv-cookies]')) {
      var btn = el('button', { type: 'button', class: 'bv-footer__cookies', 'data-bv-cookies': '' });
      btn.textContent = 'Gérer les cookies';
      copy.appendChild(d.createTextNode(' '));
      copy.appendChild(btn);
    }
    var force = /[?&]bv_cookies=1\b/.test(location.search);
    setTimeout(function () {
      var nativeBanner = d.getElementById('shopify-pc__banner');
      if (!force && nativeBanner && nativeBanner.offsetParent !== null) return;
      withPrivacy(function (cp) {
        var decided = !!storedConsent();
        var needed = true;
        if (cp) {
          try {
            var cv = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
            if (cv && cv.analytics !== '' && cv.marketing !== '' && cv.analytics != null) decided = true;
            if (typeof cp.shouldShowBanner === 'function') needed = !!cp.shouldShowBanner();
          } catch (e) { /* rien */ }
        }
        if (force || (needed && !decided)) openCookie(false);
      });
    }, force ? 50 : 1200);
  });

  /* 14. Suivi des campagnes (UTM) — enregistré seulement avec l'accord
     « mesure d'audience », puis joint au panier (attributs de commande) */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid', 'ttclid'];
  var utmNow = (function () {
    try {
      var p = new URLSearchParams(location.search);
      var o = {};
      var has = false;
      UTM_KEYS.forEach(function (k) { var v = p.get(k); if (v) { o[k] = v.slice(0, 150); has = true; } });
      if (!has) return null;
      o.landing_page = location.pathname.slice(0, 150);
      if (d.referrer && d.referrer.indexOf(location.host) === -1) o.referrer = d.referrer.slice(0, 200);
      o.ts = Date.now();
      return o;
    } catch (e) { return null; }
  })();
  var utmSyncing = false;
  function utmSync() {
    if (utmSyncing || !analyticsAllowed()) return;
    var last = store('bv-utm-last');
    if (!last) return;
    var data;
    try { data = JSON.parse(last); } catch (e) { return; }
    if (!data.ts || Date.now() - data.ts > 30 * 864e5) { store('bv-utm-last', null); return; }
    utmSyncing = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return null;
        var a = cart.attributes || {};
        var attrs = {};
        var changed = false;
        UTM_KEYS.concat(['landing_page', 'referrer']).forEach(function (k) {
          if (data[k]) { attrs[k] = data[k]; if (a[k] !== data[k]) changed = true; }
        });
        var first = store('bv-utm-first');
        if (first) {
          try {
            var f = JSON.parse(first);
            if (f.utm_source && a.first_utm_source !== f.utm_source) { attrs.first_utm_source = f.utm_source; changed = true; }
            if (f.utm_campaign && a.first_utm_campaign !== f.utm_campaign) { attrs.first_utm_campaign = f.utm_campaign; changed = true; }
          } catch (e) { /* rien */ }
        }
        if (!changed) return null;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
      })
      .catch(function () { /* silencieux : n'empêche pas l'achat */ })
      .then(function () { utmSyncing = false; });
  }
  function utmFlush() {
    if (!analyticsAllowed()) return;
    if (utmNow) {
      if (!store('bv-utm-first')) store('bv-utm-first', JSON.stringify(utmNow));
      store('bv-utm-last', JSON.stringify(utmNow));
      utmNow = null;
    }
    utmSync();
  }
  safe('utm', function () {
    withPrivacy(function () { utmFlush(); });
    if (typeof w.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      w.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(utmSync, 400); });
    }
  });

  /* 9. Copier  /  10. Imprimer */
  function copyText(t) {
    if (navigator.clipboard && w.isSecureContext) return navigator.clipboard.writeText(t).catch(function () { return legacyCopy(t); });
    return legacyCopy(t);
  }
  function legacyCopy(t) {
    return new Promise(function (res, rej) {
      var ta = el('textarea', { readonly: '' });
      ta.value = t;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      d.body.appendChild(ta);
      ta.select();
      try { if (d.execCommand('copy')) res(); else rej(); } catch (x) { rej(x); }
      d.body.removeChild(ta);
    });
  }
  function toolsHtml(url) {
    return '<div class="bv-tools">' +
      '<button type="button" class="bv-tool" data-bv-copy="' + esc(url) + '" data-bv-copy-msg="Lien copié : vous pouvez le coller où vous voulez.">' + ICON.link + '<span>Copier le lien</span></button>' +
      '<button type="button" class="bv-tool" data-bv-print>' + ICON.print + '<span>Imprimer</span></button>' +
      '</div>';
  }
  safe('copy-print', function () {
    d.addEventListener('click', function (e) {
      var c = e.target.closest('[data-bv-copy]');
      if (c) {
        e.preventDefault();
        var txt = c.getAttribute('data-bv-copy') || location.href;
        copyText(txt).then(function () {
          toast(c.getAttribute('data-bv-copy-msg') || 'Copié dans le presse-papiers.');
          c.classList.add('is-done');
          setTimeout(function () { c.classList.remove('is-done'); }, 1800);
        }, function () { toast('La copie a échoué : sélectionnez le texte et copiez-le manuellement.', { type: 'err' }); });
        return;
      }
      var p = e.target.closest('[data-bv-print]');
      if (p) { e.preventDefault(); w.print(); }
    });
    /* Fiche produit et article : outils à côté du bouton « Partager » */
    $$('share-button').forEach(function (sb) {
      var host = sb.parentElement;
      if (!host || host.querySelector('.bv-tools')) return;
      sb.insertAdjacentHTML('afterend', toolsHtml(location.origin + location.pathname));
    });
    /* E-mail et téléphone (pied de page, page contact) : bouton copier */
    $$('.bv-footer__contact a[href^="mailto:"], .bv-footer__contact a[href^="tel:"], .template-page-contact main a[href^="mailto:"], .template-page-contact main a[href^="tel:"]').forEach(function (a) {
      if (a.nextElementSibling && a.nextElementSibling.classList.contains('bv-copy-mini')) return;
      var val = a.getAttribute('href').replace(/^(mailto|tel):/, '');
      var isMail = /^mailto:/.test(a.getAttribute('href'));
      var b = el('button', { type: 'button', class: 'bv-copy-mini', 'data-bv-copy': val, 'data-bv-copy-msg': isMail ? 'Adresse e-mail copiée.' : 'Numéro de téléphone copié.', 'aria-label': isMail ? 'Copier l’adresse e-mail' : 'Copier le numéro de téléphone', title: 'Copier' }, ICON.copy);
      a.insertAdjacentElement('afterend', b);
    });
    /* Impression : on déplie tout, puis on remet en l'état */
    w.addEventListener('beforeprint', function () {
      $$('details:not([open])').forEach(function (dt) { dt.setAttribute('data-bv-print-open', ''); dt.open = true; });
      $$('.bv-reveal').forEach(function (s) { s.classList.add('is-in'); });
    });
    w.addEventListener('afterprint', function () {
      $$('details[data-bv-print-open]').forEach(function (dt) { dt.open = false; dt.removeAttribute('data-bv-print-open'); });
    });
  });

  /* 13. Œil pour afficher / masquer les mots de passe */
  function pwEye(inp) {
    if (inp.dataset.bvPw) return;
    inp.dataset.bvPw = '1';
    var host = inp.parentElement;
    if (!host) return;
    if (!host.classList.contains('field')) {
      var wrap = el('span', { class: 'bv-pw-wrap' });
      host.insertBefore(wrap, inp);
      wrap.appendChild(inp);
      host = wrap;
    }
    host.classList.add('bv-pw-host');
    inp.classList.add('bv-pw-input');
    var b = el('button', { type: 'button', class: 'bv-pw__btn', 'aria-label': 'Afficher le mot de passe', 'aria-pressed': 'false', title: 'Afficher le mot de passe' }, ICON.eye);
    if (inp.id) b.setAttribute('aria-controls', inp.id);
    inp.insertAdjacentElement('afterend', b);
    b.addEventListener('click', function () {
      var show = inp.type === 'password';
      inp.type = show ? 'text' : 'password';
      b.setAttribute('aria-pressed', show ? 'true' : 'false');
      b.setAttribute('aria-label', show ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
      b.setAttribute('title', show ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
      b.innerHTML = show ? ICON.eyeOff : ICON.eye;
      var pos = inp.value.length;
      inp.focus();
      try { inp.setSelectionRange(pos, pos); } catch (e) { /* rien */ }
    });
    if (inp.form) inp.form.addEventListener('submit', function () { inp.type = 'password'; });
  }
  safe('password', function () { $$('input[type="password"]').forEach(pwEye); });

  /* 15 + 16. Formulaires : vérification avant envoi, envoi en cours,
     message de réussite, message d'échec */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function fieldProblem(inp) {
    var v = (inp.value || '').trim();
    if (inp.type === 'checkbox') return inp.required && !inp.checked ? 'Cette case doit être cochée.' : '';
    if (inp.required && !v) return inp.type === 'email' ? 'Indiquez votre adresse e-mail.' : 'Ce champ est obligatoire.';
    if (v && inp.type === 'email' && !EMAIL_RE.test(v)) return 'Adresse e-mail invalide (exemple : nom@domaine.fr).';
    if (v && inp.type === 'tel' && !/^[+0-9 ().-]{6,20}$/.test(v)) return 'Numéro de téléphone invalide.';
    if (v && inp.minLength > 0 && v.length < inp.minLength) return 'Au moins ' + inp.minLength + ' caractères.';
    return '';
  }
  function showFieldError(inp, msg) {
    if (!inp.id) inp.id = 'bvf-' + Math.random().toString(36).slice(2, 8);
    var id = inp.id + '-bverr';
    var box = d.getElementById(id);
    if (msg) {
      if (!box) {
        box = el('p', { class: 'bv-field-err', id: id });
        var anchor = inp.closest('.field, .bv-footer__fields, .bv-news__row, .bv-pw-wrap') || inp;
        anchor.insertAdjacentElement('afterend', box);
      }
      box.textContent = msg;
      inp.setAttribute('aria-invalid', 'true');
      var db = (inp.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== id; });
      db.push(id);
      inp.setAttribute('aria-describedby', db.join(' '));
    } else {
      if (box) box.parentNode.removeChild(box);
      if (inp.getAttribute('aria-invalid') === 'true') inp.removeAttribute('aria-invalid');
      var rest = (inp.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== id; });
      if (rest.length) inp.setAttribute('aria-describedby', rest.join(' ')); else inp.removeAttribute('aria-describedby');
    }
  }
  function enhanceForm(f) {
    if (f.dataset.bvForm) return;
    f.dataset.bvForm = '1';
    f.setAttribute('novalidate', '');
    var fields = $$('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select', f);
    fields.forEach(function (inp) {
      inp.addEventListener('blur', function () { if (inp.value) showFieldError(inp, fieldProblem(inp)); });
      inp.addEventListener('input', function () { if (inp.getAttribute('aria-invalid') === 'true') showFieldError(inp, fieldProblem(inp)); });
    });
    f.addEventListener('submit', function (e) {
      var bad = [];
      fields.forEach(function (inp) { var m = fieldProblem(inp); showFieldError(inp, m); if (m) bad.push(inp); });
      if (bad.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bad[0].focus();
        f.classList.remove('bv-shake');
        void f.offsetWidth;
        if (!reduceMotion) f.classList.add('bv-shake');
        toast(bad.length > 1 ? bad.length + ' champs sont à corriger avant l’envoi.' : 'Un champ est à corriger avant l’envoi.', { type: 'err' });
        return;
      }
      var btn = f.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
      if (btn) { btn.classList.add('bv-is-loading'); btn.setAttribute('aria-busy', 'true'); }
      setTimeout(function () { if (btn) { btn.classList.remove('bv-is-loading'); btn.removeAttribute('aria-busy'); } }, 12000);
    }, true);
  }
  safe('forms', function () {
    $$('form').forEach(function (f) {
      if (f.matches('[role="search"], [action*="/cart"], [action*="/search"], [action*="/localization"], .bv-search__form, [data-type="add-to-cart-form"], .product-form form, .installment, #CartDrawer-Form')) return;
      if (f.closest('product-form, cart-drawer, [data-bv-search]')) return;
      if (!f.querySelector('input[required], textarea[required], input[type="email"], input[type="password"]')) return;
      enhanceForm(f);
    });
    w.addEventListener('pageshow', function () { $$('.bv-is-loading').forEach(function (b) { b.classList.remove('bv-is-loading'); b.removeAttribute('aria-busy'); }); });

    /* Retour du serveur après envoi */
    var qs = location.search;
    var ok = $('.bv-footer__ok, .bv-news__ok');
    if (/customer_posted=true/.test(qs) || ok) {
      toast('Merci ! Votre inscription à la newsletter est bien enregistrée.');
      if (ok) ok.setAttribute('role', 'status');
    }
    if (/contact_posted=true/.test(qs)) toast('Merci ! Votre message a bien été envoyé. Nous vous répondons sous 24 h ouvrées.');
    var errBox = $('.bv-footer__err, .bv-news__err, .form__message[role="alert"], .errors, .form-message--error');
    if (errBox) {
      errBox.setAttribute('role', 'alert');
      toast('L’envoi a échoué : vérifiez le champ signalé puis réessayez.', { type: 'err' });
      setTimeout(function () { errBox.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); }, 300);
    }
    /* Problèmes réseau */
    w.addEventListener('offline', function () { toast('Vous êtes hors ligne : vérifiez votre connexion Internet.', { type: 'err' }); });
    w.addEventListener('online', function () { toast('Connexion rétablie.'); });
  });

  /* 17. Confirmations : article retiré (avec « Annuler »), erreurs panier */
  function undoRemove(vid, qty) {
    var drawer = $('cart-drawer');
    var onCart = /^\/cart\/?$/.test(location.pathname);
    var body = { items: [{ id: parseInt(vid, 10), quantity: qty || 1 }] };
    if (drawer && !onCart && drawer.renderContents) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { toast(res.description || res.message || 'Impossible de remettre cet article dans le panier.', { type: 'err' }); return; }
        if (onCart || !drawer || !drawer.renderContents) { location.reload(); return; }
        drawer.renderContents(res);
        toast('L’article est de nouveau dans votre panier.');
      })
      .catch(function () { toast('Impossible de remettre cet article : vérifiez votre connexion.', { type: 'err' }); });
  }
  safe('confirm', function () {
    d.addEventListener('click', function (e) {
      var rb = e.target.closest('cart-remove-button');
      if (!rb) return;
      var row = rb.closest('[id^="CartDrawer-Item-"], [id^="CartItem-"]');
      if (!row) return;
      var inp = row.querySelector('[data-quantity-variant-id]');
      var vb = rb.querySelector('[data-variant-id]');
      var vid = inp ? inp.getAttribute('data-quantity-variant-id') : (vb ? vb.getAttribute('data-variant-id') : null);
      var qty = inp ? parseInt(inp.getAttribute('data-cart-quantity') || inp.value, 10) : 1;
      var nameEl = row.querySelector('.bv-cd__name, .cart-item__name');
      var name = nameEl ? nameEl.textContent.trim() : 'L’article';
      if (!vid) return;
      setTimeout(function () {
        toast('« ' + name + ' » a été retiré du panier.', { duration: 8000, action: { label: 'Annuler', fn: function () { undoRemove(vid, qty); } } });
      }, 350);
    }, true);
    if (typeof w.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      w.subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
        var m = '';
        if (ev) {
          if (typeof ev.message === 'string' && ev.message) m = ev.message;
          else if (typeof ev.errors === 'string') m = ev.errors;
          else if (ev.errors && typeof ev.errors === 'object') m = Object.keys(ev.errors).map(function (k) { return [].concat(ev.errors[k]).join(' '); }).join(' ');
        }
        toast(m || 'L’article n’a pas pu être ajouté au panier. Réessayez dans un instant.', { type: 'err' });
      });
    }
  });

  /* Date de livraison estimée (jours ouvrés) — tiroir panier */
  function addBusinessDays(from, n) {
    var dt = new Date(from.getTime());
    var added = 0;
    while (added < n) { dt.setDate(dt.getDate() + 1); var wd = dt.getDay(); if (wd !== 0 && wd !== 6) added += 1; }
    return dt;
  }
  function frDay(dt) { var j = dt.getDate(); return (j === 1 ? '1er' : j) + ' ' + MONTHS[dt.getMonth()]; }
  function etaAll(root) {
    $$('[data-bv-eta]', root).forEach(function (n) {
      var a = parseInt(n.getAttribute('data-min'), 10) || 7;
      var b = parseInt(n.getAttribute('data-max'), 10) || 10;
      var now = new Date();
      var txt = 'Livraison estimée entre le ' + frDay(addBusinessDays(now, a)) + ' et le ' + frDay(addBusinessDays(now, b));
      if (n.textContent !== txt) n.textContent = txt;
    });
  }
  safe('eta', function () {
    etaAll(d);
    var cd = $('cart-drawer');
    if (cd && 'MutationObserver' in w) {
      new MutationObserver(function () { etaAll(cd); watchImages(cd); }).observe(cd, { childList: true, subtree: true });
    }
  });

  /* 19. FAQ dépliable : animation, recherche, tout déplier, lien direct */
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60); }
  function animateDetails(det) {
    if (det.dataset.bvAcc) return;
    det.dataset.bvAcc = '1';
    var sum = det.querySelector('summary');
    var body = sum && sum.nextElementSibling;
    if (!sum || !body || reduceMotion) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (det.dataset.bvBusy) return;
      det.dataset.bvBusy = '1';
      body.style.overflow = 'hidden';
      if (det.open) {
        body.style.height = body.offsetHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'height .26s ease, opacity .26s ease';
          body.style.height = '0px';
          body.style.opacity = '0';
        });
        setTimeout(function () { det.open = false; body.removeAttribute('style'); delete det.dataset.bvBusy; }, 270);
      } else {
        det.open = true;
        var h = body.offsetHeight;
        body.style.height = '0px';
        body.style.opacity = '0';
        requestAnimationFrame(function () {
          body.style.transition = 'height .26s ease, opacity .26s ease';
          body.style.height = h + 'px';
          body.style.opacity = '1';
        });
        setTimeout(function () { body.removeAttribute('style'); delete det.dataset.bvBusy; }, 270);
      }
    });
  }
  safe('faq', function () {
    var items = $$('details.bv-faq__item');
    if (!items.length) return;
    items.forEach(function (it) {
      animateDetails(it);
      var q = it.querySelector('summary');
      if (q && !it.id) it.id = 'q-' + slug(q.textContent);
    });
    if (location.hash && location.hash.indexOf('#q-') === 0) {
      var target = d.getElementById(location.hash.slice(1));
      if (target && target.tagName === 'DETAILS') { target.open = true; setTimeout(function () { target.scrollIntoView({ block: 'center' }); }, 200); }
    }
    var sections = $$('.bv-faq');
    if (sections.length < 2 && items.length < 6) return;
    var heading = $('#MainContent .bv-heading') || sections[0];
    var bar = el('div', { class: 'bv-faqtools' });
    bar.innerHTML =
      '<label class="bv-faqtools__search">' + ICON.search + '<span class="bv-visually-hidden">Rechercher dans les questions</span>' +
      '<input type="search" placeholder="Rechercher une question (livraison, retour, paiement…)" autocomplete="off"></label>' +
      '<button type="button" class="bv-faqtools__btn" aria-pressed="false">Tout déplier</button>' +
      '<p class="bv-faqtools__count" aria-live="polite"></p>';
    heading.insertAdjacentElement('afterend', bar);
    var input = $('input', bar);
    var btn = $('button', bar);
    var count = $('.bv-faqtools__count', bar);
    btn.addEventListener('click', function () {
      var openAll = btn.getAttribute('aria-pressed') !== 'true';
      items.forEach(function (it) { if (!it.classList.contains('is-hidden')) it.open = openAll; });
      btn.setAttribute('aria-pressed', openAll ? 'true' : 'false');
      btn.textContent = openAll ? 'Tout replier' : 'Tout déplier';
    });
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var q = norm(input.value.trim());
        var shown = 0;
        items.forEach(function (it) {
          var match = !q || norm(it.textContent).indexOf(q) > -1;
          it.classList.toggle('is-hidden', !match);
          if (match) shown += 1;
          if (q && match) it.open = true;
        });
        sections.forEach(function (s) { s.classList.toggle('is-hidden', !!q && !s.querySelector('.bv-faq__item:not(.is-hidden)')); });
        count.textContent = q ? (shown ? shown + ' question' + (shown > 1 ? 's' : '') + ' trouvée' + (shown > 1 ? 's' : '') : 'Aucune question ne correspond. Contactez-nous : nous répondons du lundi au vendredi.') : '';
      }, 150);
    });
  });
})();
